import React, { useState } from "react";
import { IconMoon, IconSun } from "@tabler/icons-react";

export default function ThemeToggle({ inline = false }: { inline?: boolean }) {
  const [dark, setDark] = useState(() => document.documentElement.classList.contains("dark"));

  function changeTheme(nextDark: boolean) {
    setDark(nextDark);
    document.documentElement.classList.toggle("dark", nextDark);
    try {
      localStorage.setItem("cadlogin-theme", nextDark ? "dark" : "light");
    } catch {
      // A escolha continua funcionando quando o armazenamento esta indisponivel.
    }
  }

  return (
    <div className={inline ? "theme-toolbar theme-toolbar-inline" : "theme-toolbar"}>
      <div className="theme-toggle" role="group" aria-label="Tema da interface">
        <button type="button" aria-label="Usar tema claro" title="Usar tema claro" aria-pressed={!dark} onClick={() => changeTheme(false)}>
          <IconSun size={18} aria-hidden="true" />
        </button>
        <button type="button" aria-label="Usar tema escuro" title="Usar tema escuro" aria-pressed={dark} onClick={() => changeTheme(true)}>
          <IconMoon size={18} aria-hidden="true" />
        </button>
      </div>
    </div>
  );
}
